import React from 'react';
import PropTypes from 'prop-types';
import { buildImagePath } from '../../Content/User/UserDisplay/UserImage/UserImage';
import { COMPANY_BADGE_IMAGE_SOURCES } from '../../Includes/CompanyProps';
import './Badge.scss';

export default class Badge extends React.PureComponent {
    render() {
        const injectedTransforms = {
            small: 'c_scale,w_107,h_99',
        };

        // Use custom imageUrl if provided, otherwise fall back to predefined sources
        const imagePath =
            this.props.imageUrl || COMPANY_BADGE_IMAGE_SOURCES[this.props.type];
        if (!imagePath) {
            return null;
        }

        const src = buildImagePath(imagePath, 'small', injectedTransforms);

        return (
            <a href={this.props.link} target="_blank" rel="noopener noreferrer">
                <div className="component-Elements-Badge">
                    <img src={src} alt={`${this.props.type} badge`} />
                </div>
            </a>
        );
    }
}

Badge.propTypes = {
    /**
     * badge type
     */
    type: PropTypes.string.isRequired,
    /**
     * custom image URL (optional, overrides COMPANY_BADGE_IMAGE_SOURCES)
     */
    imageUrl: PropTypes.string,
    link: PropTypes.string,
};

Badge.defaultProps = {
    imageUrl: null,
    link: null,
};
